const eventFire = (type) => {
	const evt = new Event(type);
	document.dispatchEvent(evt);
};

export default eventFire;
